import script from "./ConfirmModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmModal.vue?vue&type=style&index=0&id=dd5924fe&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd5924fe"]])

export default __exports__